<form autocomplete="off" [formGroup]="form">
  <div class="row">
    <div class="col-sm-12 email-integration-toggle">
      <p-toggleswitch
        [formControl]="form.controls.mailIntegrationEnabled"
        inputId="mail-integration-enabled"
      >
      </p-toggleswitch>
      <label class="form-control-label" for="mail-integration-enabled"
        >Enable e-mail integration</label
      >
    </div>
  </div>
  @if (form.value.mailIntegrationEnabled) {
    <div>
      <div class="row my-2">
        <div class="col-12">
          <p-select
            formControlName="emailIntegrationType"
            [options]="emailIntegrationTypeList"
            (onChange)="onEmailIntegrationTypeSelectChange()"
          >
          </p-select>
        </div>
      </div>
      @if (currentEmailIntegrationType === EmailIntegrationType.SMTP) {
        <div>
          <div class="row m-t-10">
            <div class="col-sm-12">
              <span class="form-control-label required">E-mail username</span>
              <input
                pInputText
                class="form-control"
                autocomplete="off"
                formControlName="mailUsername"
                placeholder="E-mail username"
              />
            </div>
          </div>
          <div class="row m-t-10">
            <div class="col-sm-12">
              <span class="form-control-label required">E-mail password</span>
              <input
                pInputText
                class="form-control"
                type="password"
                autocomplete="new-password"
                formControlName="mailPassword"
                placeholder="E-mail password"
              />
            </div>
          </div>
          <div class="row centered m-t-20">
            <div class="col-sm-12">
              <button
                pButton
                size="large"
                severity="success"
                (click)="testEmailIntegration()"
                [disabled]="loadingEmailIntegration || !form.value.mailPassword"
              >
                @if (loadingEmailIntegration) {
                  <i class="pi pi-spinner"></i>
                }
                Test integration
              </button>
            </div>
          </div>
          <div>
            <div class="row m-t-10">
              <div class="col-sm-12">
                <span class="form-control-label"
                  >Folder to save outgoing quotes</span
                >
              </div>
            </div>
            <div class="row m-t-10">
              <div class="col-sm-12">
                @if (mailboxFolderListSmtp.length) {
                  <p-select
                    [options]="mailboxFolderListSmtp"
                    formControlName="mailImapPath"
                    [filter]="true"
                    filterBy="label, value"
                    placeholder="Please select"
                  >
                  </p-select>
                }
                @if (!mailboxFolderListSmtp.length) {
                  <p-select [disabled]="true"> </p-select>
                }
              </div>
            </div>
          </div>
        </div>
      }
      @if (currentEmailIntegrationType === EmailIntegrationType.OFFICE_365) {
        <div class="email-integration-actions">
          @if (!isLoggedIn) {
            <button pButton severity="success" (click)="login()">Log in</button>
          } @else {
            <button
              pButton
              severity="danger"
              outlined="true"
              (click)="disconnect()"
            >
              Disconnect
            </button>
            <button
              pButton
              severity="success"
              (click)="testEmailIntegration()"
              [disabled]="loadingEmailIntegration"
            >
              @if (loadingEmailIntegration) {
                <i class="pi pi-spinner"></i>
              }
              Test integration
            </button>
          }
        </div>
      }
    </div>
  }
</form>
